var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Transform } from 'class-transformer';
import { IsArray, IsOptional, IsUUID } from 'class-validator';
const toStringArray = ({ value }) => {
    if (value == null)
        return undefined;
    if (Array.isArray(value))
        return value.map(String);
    return String(value).split(',').filter(Boolean);
};
export class CalendarAppointmentsFilterDto {
    therapistIds;
    roomIds;
    deviceIds;
}
__decorate([
    Expose(),
    Transform(toStringArray),
    IsOptional(),
    IsArray(),
    IsUUID('4', { each: true }),
    __metadata("design:type", Array)
], CalendarAppointmentsFilterDto.prototype, "therapistIds", void 0);
__decorate([
    Expose(),
    Transform(toStringArray),
    IsOptional(),
    IsArray(),
    IsUUID('4', { each: true }),
    __metadata("design:type", Array)
], CalendarAppointmentsFilterDto.prototype, "roomIds", void 0);
__decorate([
    Expose(),
    Transform(toStringArray),
    IsOptional(),
    IsArray(),
    IsUUID('4', { each: true }),
    __metadata("design:type", Array)
], CalendarAppointmentsFilterDto.prototype, "deviceIds", void 0);
//# sourceMappingURL=calendar-appointments-filter.dto.js.map